export const normalizarLote = (value, max = 25) =>
  String(value || "")
    .trim()
    .replace(/\s/g, "")
    .toUpperCase()
    .slice(0, max);

export const normalizarVto = (value, max = 8) =>
  String(value || "")
    .replace(/\D/g, "")
    .slice(0, max);